import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);

export function ActiveClientProvider({ children }) {
  const [clients, setClients] = useState([]);
  const [activeClientId, setActive] = useState(localStorage.getItem("ap_active_client") || "");

  const refresh = () =>
    api.get("/clients").then((r) => {
      setClients(r.data);
      setActive((prev) => (prev && r.data.some((c) => c.id === prev) ? prev : r.data[0]?.id || ""));
    });

  useEffect(() => { refresh(); }, []);
  useEffect(() => { if (activeClientId) localStorage.setItem("ap_active_client", activeClientId); }, [activeClientId]);

  const setActiveClientId = (id) => setActive(id);
  const activeClient = clients.find((c) => c.id === activeClientId) || null;

  return (
    <Ctx.Provider value={{ clients, activeClientId, setActiveClientId, activeClient, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export const useActiveClient = () => useContext(Ctx);
